<template>
    <section class="content">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 v-if="modo === 'crear'">CREAR ORDEN DE VENTA No: {{ numControl }}</h1>
                        <h1 v-else-if="modo === 'editar'">EDITAR ORDEN DE VENTA No: {{ numControl }}</h1>
                        <h1 v-else-if="modo === 'despacho'">
                            CONFIRMAR DESPACHO No: {{ numControl }}
                        </h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item active">Venta</li>
                        </ol>
                    </div>

                </div>
            </div>
        </section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <ul class="d-flex w-100 p-2 m-0 list-unstyled justify-content-between">
                        <li v-for="s in steps" :key="s.id" class="d-flex align-items-center"
                            :style="{ flex: s.id < steps.length ? 1 : '0' }">
                            <!-- Paso circular -->
                            <a href="javascript:void(0)" @click.prevent="goStep(s.id)"
                                class="rounded-circle border d-flex justify-content-center align-items-center" :class="{
                                    'bg-lightblue text-white border-lightblue': paso >= s.id,
                                    'text-secondary border-secondary': paso < s.id
                                }" style="width: 2.5rem; height: 2.5rem;">
                                {{ s.id }}
                            </a>
                            <!-- Línea de conexión -->
                            <div v-if="s.id < steps.length" class="flex-grow-1 mx-2"
                                :class="paso > s.id ? 'bg-lightblue' : 'bg-secondary'" style="height: 2px;"></div>
                        </li>
                    </ul>
                    <!-- STEP 1: Datos del Cliente -->
                    <div v-if="paso === 1" ref="step1" class="card">
                        <div class="card-header bg-lightblue">
                            <h3>1. Datos del Cliente</h3>
                        </div>
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-md-3">
                                    <label>Tipo</label>
                                    <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
                                        <label class="btn btn-outline-primary flex-fill"
                                            :class="{ active: tipoCliente === 'frecuente', disabled: modo !== 'crear' }">
                                            <input type="radio" v-model="tipoCliente" value="frecuente"
                                                :disabled="modo !== 'crear'" />
                                            Frecuente
                                        </label>
                                        <label class="btn btn-outline-secondary flex-fill"
                                            :class="{ active: tipoCliente === 'nuevo', disabled: modo !== 'crear' }">
                                            <input type="radio" v-model="tipoCliente" value="nuevo"
                                                :disabled="modo !== 'crear'" />
                                            Nuevo
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <label>Nombre</label>
                                    <div class="input-group">
                                        <input v-model="clienteSeleccionado.nombre" class="form-control" required
                                            placeholder="Ej.: SUPERMERCADO C.A"
                                            :disabled="tipoCliente === 'frecuente' || modo !== 'crear'" />
                                        <div class="input-group-append">
                                            <button :disabled="tipoCliente === 'nuevo' || modo !== 'crear'"
                                                class="btn btn-primary" type="button"
                                                @click="abrirModalCliente">Buscar</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label>Código</label>
                                    <input v-model="clienteSeleccionado.codigo" class="form-control"
                                        :disabled="tipoCliente === 'frecuente' || modo !== 'crear'"
                                        placeholder="Ej.: ABC0001" />
                                </div>
                                <div class="col-md-2">
                                    <label>RIF/C.I</label>
                                    <input v-model="clienteSeleccionado.rif" class="form-control" required
                                        placeholder="Ej.: J123456789"
                                        :disabled="tipoCliente === 'frecuente' || modo !== 'crear'" />
                                </div>
                                <div class="col-md-2">
                                    <label>Teléfono</label>
                                    <input v-model="clienteSeleccionado.telefono" class="form-control"
                                        placeholder="Ej.: 04240000000"
                                        :disabled="tipoCliente === 'frecuente' || modo !== 'crear'" />
                                </div>
                                <div class="col-md-6">
                                    <label>Dirección</label>
                                    <input v-model="clienteSeleccionado.direccion" class="form-control" required
                                        placeholder="Ej.: Calle Principal Sector Pensil Puerto La Cruz"
                                        :disabled="tipoCliente === 'frecuente' || modo !== 'crear'" />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex w-100">
                                <button class="btn btn-secondary">
                                    Cancelar
                                </button>
                                <button v-if="modo === 'crear'" class="btn btn-danger mx-auto"
                                    @click="limpiarCliente">Limpiar</button>
                                <button class="btn btn-success" @click="nextStep"
                                    :disabled="!clienteSeleccionado.nombre">Siguiente</button>
                            </div>
                        </div>
                    </div>
                    <!-- STEP 2: Datos de la venta -->
                    <div class="card" ref="step2" v-if="paso === 2">
                        <div class="card-header bg-lightblue">
                            <h3>2. Datos de la venta</h3>
                        </div>
                        <div class="card-body">
                            <div class="row g-3 justify-content-between">
                                <div class="col-md-2">
                                    <label for="No">No. Control</label>
                                    <input type="text" class="form-control" id="numcontrol" v-model="numControl"
                                        disabled>
                                </div>
                                <div class="col-md-2">
                                    <label for="formaPago">Tipo de Venta</label>
                                    <select class="form-control" id="formaPago" v-model="tipoPago" required>
                                        <option value="contado">Contado</option>
                                        <option value="credito" v-if="credito && credito.credito_disponible !== 0">
                                            Credito
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <label for="fecha">Fecha de Venta</label>
                                    <input type="date" class="form-control" id="fecha" v-model="fechaVenta" required>
                                </div>
                                <div class="col-md-2" v-if="modo === 'despacho'">
                                    <label for="fecha">Fecha de Entrega</label>
                                    <input type="date" class="form-control" id="fecha" v-model="fechaEntrega" required>
                                </div>
                                <div class="col-md-2">
                                    <label for="vendedor">Vendedor</label>
                                    <select class="form-control" id="vendedor" v-model="vendedor" required>
                                        <option value="WILLINSON MICEL">Willinson Micel</option>
                                        <option value="RAFAEL LOPEZ">Rafael Lopez</option>
                                        <option value="ELIAS FREITES">Elias Freites</option>
                                        <option value="OVIDIO LOPEZ">Ovidio Lopez</option>
                                    </select>
                                </div>

                            </div>
                            <div v-if="modo === 'despacho'" class="row g-3 mt-3">
                                <div class="col-md-6">
                                    <label>Responsable de Entrega</label>
                                    <select class="form-control" id="responsable"
                                        v-model="logistica.responsable_entrega" required>
                                        <option value="WILLINSON MICEL">Willinson Micel</option>
                                        <option value="RAFAEL LOPEZ">Rafael Lopez</option>
                                        <option value="ELIAS FREITES">Elias Freites</option>
                                        <option value="OVIDIO LOPEZ">Ovidio Lopez</option>
                                        <option value="ANTONIO VAIS">Antonio Vais</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label>Recibido Por</label>
                                    <input v-model="logistica.recibido_por" class="form-control" required
                                        placeholder="Nombre de quien recibe en local" />
                                </div>
                            </div>
                            <div v-if="credito">
                                <div class="row g-3 justify-content-between">
                                    <div class="col-md-2">
                                        <label for="estatus">Estatus de credito</label>
                                        <input type="text" class="form-control" id="estatusCredito"
                                            v-model="credito.estatus" disabled>
                                    </div>
                                    <div class="col-md-2">
                                        <label for="limite">Limite de credito</label>
                                        <input type="text" class="form-control" id="limiteCredito"
                                            v-model="credito.limite" disabled>
                                    </div>
                                    <div class="col-md-2">
                                        <label for="deuda">Deuda</label>
                                        <input type="text" class="form-control" id="deudaCredito"
                                            v-model="credito.deuda" disabled>
                                    </div>
                                    <div class="col-md-2">
                                        <label for="disponible">Credito disponible</label>
                                        <input type="text" class="form-control" id="disponibleCredito"
                                            v-model="credito.credito_disponible" disabled>
                                    </div>
                                </div>
                            </div>
                            <div v-if="promociones.length" class="promotions-wrapper my-4">
                                <div class="card border-teal shadow-sm">
                                    <div class="card-header bg-success text-white d-flex align-items-center">
                                        <i class="bi bi-gift-fill me-2"></i>
                                        <h5 class="mb-0">Promociones disponibles</h5>
                                    </div>
                                    <ul class="list-group list-group-flush">
                                        <li v-for="p in promociones" :key="p.id"
                                            class="list-group-item d-flex justify-content-between align-items-center">
                                            <span>
                                                <strong class="text-success">{{ p.codigo }}</strong> — {{ p.descripcion
                                                }}
                                            </span>
                                            <span class="badge bg-success rounded-pill">Ver</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex w-100">
                                <button class="btn btn-secondary" @click="prevStep">
                                    Atras
                                </button>
                                <button class="btn btn-danger mx-auto" @click="limpiarDatos">Limpiar</button>
                                <button class="btn btn-success" @click="nextStep">Siguiente</button>
                            </div>
                        </div>
                    </div>
                    <!-- STEP 3: Productos -->
                    <div class="card" ref="step3" v-if="paso === 3">
                        <div class="card-header bg-lightblue">
                            <h3>3. Productos</h3>
                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-bordered table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th v-if="modo === 'despacho'" style="width: 40px;">Verif.</th>
                                        <th style="width: 8%;">Codigo</th>
                                        <th>Descripcion</th>
                                        <th style="width: 7%;">Cantidad</th>
                                        <th style="width: 10%;">Precio/UN</th>
                                        <th style="width: 10%;">Monto</th>
                                        <th style="width: 7%;">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(producto, index) in productosSeleccionados" :key="producto.id"
                                        :class="{ 'table-success': modo === 'despacho' && producto.verificado }">
                                        <td v-if="modo === 'despacho'" class="text-center">
                                            <input type="checkbox" v-model="producto.verificado">
                                        </td>
                                        <td>{{ producto.codigo }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td>
                                            <input type="number" v-model.number="producto.cantidad"
                                                class="form-control form-control-sm" @change="evaluarPromociones">
                                        </td>
                                        <td>{{ calcularPrecioUn(producto) }}</td>
                                        <td>{{ calcularMonto(producto) }}</td>
                                        <td>
                                            <button class="btn btn-danger btn-sm" @click="eliminarProducto(index)"><i
                                                    class="fas fa-trash"></i></button>
                                        </td>
                                    </tr>
                                    <!-- Fila de Obsequios para Verificación en Despacho -->
                                    <tr v-for="(obs, idx) in obsequios" :key="'obs-' + idx" class="table-info"
                                        :class="{ 'table-success': modo === 'despacho' && obs.verificado }">
                                        <td v-if="modo === 'despacho'" class="text-center">
                                            <input type="checkbox" v-model="obs.verificado">
                                        </td>
                                        <td>{{ obs.codigo }}</td>
                                        <td><span class="badge badge-info">OBSEQUIO</span> {{ obs.nombre }}</td>
                                        <td>{{ obs.cantidad }}</td>
                                        <td>0.00</td>
                                        <td>0.00</td>
                                        <td></td>
                                    </tr>
                                    <tr class="text-center">
                                        <td colspan="6"><button @click="abrirModalProducto"
                                                class="btn btn-outline-primary">Presiona para agregar producto</button>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot class="border-t">
                                    <tr v-if="descuentoTotal > 0">
                                        <td colspan="5" class="text-right pr-4"><strong>Subtotal:</strong></td>
                                        <td class="text-right">{{ subtotal.toFixed(2) }}</td>
                                    </tr>
                                    <tr v-if="descuentoTotal > 0">
                                        <td colspan="5" class="text-right pr-4"><strong>Descuento:</strong></td>
                                        <td class="text-right">- {{ descuentoTotal.toFixed(2) }}</td>
                                    </tr>
                                    <tr class="font-bold">
                                        <td colspan="5" class="text-right pr-4"><strong>Total:</strong></td>
                                        <td class="text-right">{{ total.toFixed(2) }}</td>
                                    </tr>
                                    <tr v-if="observaciones.length">
                                        <td colspan="6">
                                            <strong>Observaciones:</strong>
                                            <ul class="list-disc pl-5">
                                                <li v-for="(txt, i) in observaciones" :key="i">{{ txt }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr v-if="obsequios.length">
                                        <td colspan="6">
                                            <strong>Obsequios:</strong>
                                            <ul>
                                                <li v-for="obs in obsequios">
                                                    {{ obs.codigo }}: {{ obs.nombre }} - Cantidad: {{ calcularCJyUN(obs)
                                                    }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex w-100">
                                <button class="btn btn-secondary" @click="prevStep">
                                    Atras
                                </button>
                                <button class="btn btn-danger mx-auto" @click="limpiarTabla">Limpiar</button>
                                <button class="btn btn-success" @click="nextStep"
                                    :disabled="productosSeleccionados.length === 0">Siguiente</button>
                            </div>
                        </div>
                    </div>
                    <!-- STEP 4: Vista previa -->
                    <div class="card" ref="step4" v-if="paso === 4">
                        <div class="card-header bg-lightblue">
                            <h3 class="card-title">4. Vista previa</h3>
                        </div>
                        <div class="card-header">
                            <h5>DATOS DEL CLIENTE</h5>
                            <dl class="row">
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>Código</dt>
                                    <dd>{{ clienteSeleccionado.codigo || 'NA' }}</dd>
                                </div>
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>Nombre</dt>
                                    <dd>{{ clienteSeleccionado.nombre }}</dd>
                                </div>
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>RIF/C.I</dt>
                                    <dd>{{ clienteSeleccionado.rif }}</dd>
                                </div>
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>Contacto</dt>
                                    <dd>{{ clienteSeleccionado.telefono }}</dd>
                                </div>
                                <div class="col-12 col-lg-8 mb-3">
                                    <dt>Dirección</dt>
                                    <dd>{{ clienteSeleccionado.direccion }}</dd>
                                </div>
                            </dl>

                            <h5 class="mt-4">DATOS DE LA VENTA</h5>
                            <dl class="row">
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>No. Control</dt>
                                    <dd>{{ numControl }}</dd>
                                </div>
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>Fecha de Venta</dt>
                                    <dd>{{ fechaVenta }}</dd>
                                </div>
                                <div class="col-6 col-lg-4 mb-3">
                                    <dt>Tipo de Venta</dt>
                                    <dd>{{ tipoPago }}</dd>
                                </div>
                                <div v-if="modo === 'despacho'" class="col-12">
                                    <h5 class="mt-2">DATOS DE ENTREGA</h5>
                                    <dl class="row">
                                        <div class="col-6">
                                            <dt>Fecha de Entrega</dt>
                                            <dd>{{ fechaEntrega }}</dd>
                                        </div>
                                        <div class="col-6">
                                            <dt>Responsable:</dt>
                                            <dd>{{ logistica.responsable_entrega }}</dd>
                                        </div>
                                        <div class="col-6">
                                            <dt>Recibido por:</dt>
                                            <dd>{{ logistica.recibido_por }}</dd>
                                        </div>
                                    </dl>
                                </div>
                            </dl>
                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-bordered table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th style="width: 8%;">Codigo</th>
                                        <th>Descripcion</th>
                                        <th style="width: 7%;">Cantidad</th>
                                        <th style="width: 10%;">Precio/UN</th>
                                        <th style="width: 10%;">Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="producto in productosSeleccionados" :key="producto.id">
                                        <td>{{ producto.codigo }}</td>
                                        <td>{{ producto.descripcion }}</td>
                                        <td>{{ calcularCJyUN(producto) }}</td>
                                        <td>{{ calcularPrecioUn(producto) }}</td>
                                        <td>{{ calcularMonto(producto) }}</td>
                                    </tr>
                                </tbody>

                                <tfoot class="border-t">
                                    <tr v-if="descuentoTotal > 0">
                                        <td colspan="4" class="text-right pr-4"><strong>Subtotal:</strong></td>
                                        <td class="text-right">{{ subtotal.toFixed(2) }}</td>
                                    </tr>
                                    <tr v-if="descuentoTotal > 0">
                                        <td colspan="4" class="text-right pr-4"><strong>Descuento:</strong></td>
                                        <td class="text-right">- {{ descuentoTotal.toFixed(2) }}</td>
                                    </tr>
                                    <tr class="font-bold">
                                        <td colspan="4" class="text-right pr-4"><strong>Total:</strong></td>
                                        <td class="text-right">{{ total.toFixed(2) }}</td>
                                    </tr>
                                    <tr v-if="observaciones.length">
                                        <td colspan="5">
                                            <strong>Observaciones:</strong>
                                            <ul class="list-disc pl-5">
                                                <li v-for="(txt, i) in observaciones" :key="i">{{ txt }}</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr v-if="obsequios.length">
                                        <td colspan="5">
                                            <strong>Obsequios:</strong>
                                            <ul>
                                                <li v-for="obs in obsequios">
                                                    {{ obs.codigo }}: {{ obs.nombre }} - Cantidad: {{ calcularCJyUN(obs)
                                                    }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex w-100 justify-content-between">
                                <button class="btn btn-secondary" @click="prevStep">
                                    Atras
                                </button>
                                <button class="btn btn-success" @click="nextStep">
                                    {{ modo === 'despacho' ? 'Confirmar Entrega' : 'Guardar' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="cargando" class="overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
    </section>
    <AgregarProductoModal ref="modalAgregarProducto" @producto-seleccionado="agregarProducto" />
    <SeleccionarClienteModal ref="modalSeleccionCliente" @cliente-seleccionado="asignarCliente" />
</template>
<script>
import AgregarProductoModal from "@/components/AgregarProductoModal.vue";
import SeleccionarClienteModal from "./SeleccionarClienteModal.vue";
import api from "@/services/api";
import { loading } from '@/plugins/loading';
import Swal from 'sweetalert2';

export default {
    components: { AgregarProductoModal, SeleccionarClienteModal },
    props: {
        id: { type: [String, Number], default: null },
        modo: { type: String, default: 'crear' } // 'crear', 'editar', 'despacho'
    },
    data() {
        return {
            tipoCliente: 'frecuente',
            numControl: "",
            clienteSeleccionado: {},
            venta_id: null, // ID real de la venta en DB
            despacho_id: null,
            productosSeleccionados: [],
            tipoPago: "contado",
            fechaVenta: "",
            fechaEntrega: "",
            vendedor: "",
            subtotal: 0,
            ivatotal: 0,
            totalVentaUSD: 0,
            detalles: {},
            credito: null,
            paso: 1,
            isEditable: false,
            steps: [
                { id: 1, label: 'Datos del Cliente' },
                { id: 2, label: 'Datos de Venta' },
                { id: 3, label: 'Seleccionar Productos' },
                { id: 4, label: 'Vista Previa' }
            ],
            promociones: [],
            promosAplicadas: [],
            descuentoTotal: 0,
            total: 0,
            observaciones: [],
            obsequios: [],
            logistica: {
                responsable_entrega: '',
                recibido_por: ''
            },
            cargando: false
        };
    },
    watch: {
        tipoCliente() {
            this.limpiarCliente()
        },
        clienteSeleccionado: {
            handler() {
                this.obtenerCreditoCliente()
                this.obtenerPromocionesCliente()
                    .then(() => this.evaluarPromociones())
            },
            deep: true
        }
    },
    methods: {
        abrirModalCliente() {
            this.$refs.modalSeleccionCliente.abrirModal(); // Abre el modal de clientes
        },
        abrirModalProducto() {
            this.$refs.modalAgregarProducto.abrirModal(); // Abre el modal de productos
        },
        asignarCliente(datosCliente) {
            this.clienteSeleccionado = datosCliente; // Guarda el cliente seleccionado
        },
        obtenerCreditoCliente() {
            if (!this.clienteSeleccionado.id) {
                this.credito = null;
                return;
            }
            api
                .get(`/clientes/${this.clienteSeleccionado.id}/credito`)
                .then(response => {
                    // Se espera que el endpoint retorne { credito: { ... } }
                    this.credito = response.data.credito;
                })
                .catch(error => {
                    console.error("Error al obtener el crédito:", error.response ? error.response.data : error.message);
                    this.credito = null;
                });
        },
        async obtenerPromocionesCliente() {
            // Reiniciamos el array antes de cada llamada
            this.promociones = []

            console.log(
                'solicitando promociones para el cliente:',
                this.clienteSeleccionado.id
            )

            try {
                const response = await api.get(
                    `/promcliente/${this.clienteSeleccionado.id}`
                )
                // Asignamos los datos resueltos
                this.promociones = response.data
                console.log('Promociones obtenidas:', this.promociones)
            } catch (error) {
                console.error('Error al obtener promociones:', error)
            }
        },


        agregarProducto(producto, cant) {
            this.productosSeleccionados.push({
                ...producto,
                cantidad: cant,
                descuentoLineal: 0
            });
            this.evaluarPromociones();
        },
        calcularPrecioUn(producto) {
            if (!producto.precunid || !producto.porciva) return 0; // Previene `NaN`

            return (Number(producto.precunid) + Number(producto.porciva));
        },
        calcularMonto(producto) {
            if (!producto.precunid || !producto.porciva) return 0; // Previene `NaN`
            let resultado = (Number(producto.precunid) + Number(producto.porciva)) * Number(producto.cantidad);
            return (resultado.toFixed(2))
        },
        calcularCJyUN(p) {
            const cantxcaja = p.cantxcaja;
            const cantidad = p.cantidad

            // cajas completas (entero)
            const cajas = Math.floor(cantidad / cantxcaja);

            // unidades sobrantes
            const unidades = cantidad % cantxcaja;

            // variable mutable para concatenar
            let cajasYunidades = '';

            if (cajas > 0) {
                cajasYunidades = `${cajas}CJ`;

                if (unidades > 0) {
                    cajasYunidades += ` + ${unidades}UN`;
                }
            } else {
                // no hay ninguna caja completa
                cajasYunidades = `${unidades}UN`;
            }

            return cajasYunidades;
        },
        eliminarProducto(index) {
            this.productosSeleccionados.splice(index, 1); // Elimina el producto de la lista
            this.evaluarPromociones();
        },
        evaluarPromociones() {
            // El motor de promociones se activa para recalcular obsequios y descuentos

            if (this.productosSeleccionados.length === 0) {
                this.obsequios = [];
                this.descuentoTotal = 0;
                this.promosAplicadas = [];
                this.total = this.subtotal = 0;
                return;
            }

            const hoy = new Date();
            this.promosAplicadas = [];
            this.obsequios = [];
            this.descuentoTotal = 0;
            this.observaciones = [];

            // 1) Reiniciar descuentoLineal en cada producto
            this.productosSeleccionados.forEach(p => {
                p.descuentoLineal = 0;
            });

            for (const promo of this.promociones) {
                if (promo.estado !== 'activa') continue;
                const inicio = new Date(promo.fecha_inicio);
                if (hoy < inicio) continue;

                // Solo si fecha_fin está definida y no es null
                if (promo.fecha_fin) {
                    const fin = new Date(promo.fecha_fin);
                    if (hoy > fin) continue;
                }

                // IDs de productos a los que aplica
                const promoIds = Array.isArray(promo.productos)
                    ? promo.productos.map(x => typeof x === 'object' ? Number(x.id) : Number(x))
                    : [];

                // Seleccionar líneas según la promo
                const productosAplican = (promo.all_products == 1 || promo.all_products === true)
                    ? this.productosSeleccionados
                    : this.productosSeleccionados.filter(p => promoIds.includes(Number(p.id)));
                if (!productosAplican.length) continue;

                // Calcular subtotal y unidades
                const montoAplicable = productosAplican.reduce((sum, p) => {
                    const pu = Number(p.precunid) + Number(p.porciva);
                    return sum + pu * Number(p.cantidad);
                }, 0);

                const cantidadAplicable = productosAplican
                    .reduce((sum, p) => sum + Number(p.cantidad), 0);

                console.log(`Evaluando Promo: ${promo.codigo}`, {
                    montoVenta: montoAplicable,
                    minRequerido: promo.min_monto,
                    aplica: montoAplicable >= promo.min_monto
                });

                if (montoAplicable < promo.min_monto) continue;
                if (cantidadAplicable < promo.min_cantidad) continue;

                // a) Descuento global de la promo
                if (promo.modo === 'descuento') {
                    // monto total de descuento
                    const valorPromo = Number(promo.valor);
                    const desc = promo.tipo_valor === 'porcentaje'
                        ? montoAplicable * (valorPromo / 100)
                        : Math.min(valorPromo, montoAplicable);

                    // acumular en total venta
                    this.descuentoTotal += desc;

                    // distribuir ese desc entre cada línea proporcionalmente
                    productosAplican.forEach(p => {
                        const pu = Number(p.precunid) + Number(p.porciva);
                        const lineaTotal = pu * Number(p.cantidad);
                        const parte = (lineaTotal / montoAplicable) * desc;
                        // sumarlo a cualquier otro descuento previo
                        p.descuentoLineal = Number((p.descuentoLineal + parte).toFixed(2));
                    });

                    this.observaciones.push(
                        `${promo.codigo}: ${promo.descripcion} (-${promo.valor}${promo.tipo_valor === 'porcentaje' ? '%' : '$'} total)`
                    );

                    this.promosAplicadas.push({
                        ...promo,
                        montoDescuento: Number(desc.toFixed(2)),
                        totalObsequios: 0
                    });
                }

                // b) Obsequios (sin cambios en descuentos)
                else if (promo.modo === 'obsequio') {
                    const acumulador = new Map();
                    for (const p of productosAplican) {
                        const raw = (p.cantidad * promo.obsequio_porcentaje) / 100;
                        if (raw <= 0) continue;
                        const key = promo.obsequio_producto_id;
                        if (!acumulador.has(key)) acumulador.set(key, { rawSum: 0 });
                        acumulador.get(key).rawSum += raw;
                    }
                    console.log(promo)
                    let totalGift = 0;
                    for (const [id, { rawSum }] of acumulador) {
                        const qty = Math.floor(rawSum);
                        if (qty <= 0) continue;
                        totalGift += qty;
                        this.observaciones.push(
                            `${promo.codigo}: ${promo.descripcion} (${promo.obsequio_porcentaje}%) → ${qty} obsequio(s)`
                        );
                        this.obsequios.push({ id, codigo: promo.obsequio_producto.codigo, nombre: promo.obsequio_producto.descripcion, cantidad: qty, promocion_id: promo.id, cantxcaja: promo.obsequio_producto.cantxcaja });
                    }

                    if (totalGift > 0) {
                        this.promosAplicadas.push({
                            ...promo,
                            montoDescuento: 0,
                            totalObsequios: totalGift
                        });
                    }
                }

            }
            // Recalcular subtotales y totales finales
            this.calcularTotales();
        },
        // 3.2 Calcular subtotal, descuentoTotal y total
        calcularTotales() {
            // 1) Subtotal sin descuentos
            this.subtotal = this.productosSeleccionados
                .reduce((sum, p) => sum + (Number(p.precunid) * Number(p.cantidad)), 0)
            this.ivatotal = this.productosSeleccionados
                .reduce((sum, p) => sum + (Number(p.porciva) * Number(p.cantidad)), 0)
            // 2) Total final (restar los descuentos ya calculados)
            this.total = (this.subtotal + this.ivatotal) - this.descuentoTotal
        },
        async obtenerNumeroControl() {
            try {
                const response = await api.get(`/ultimo-num-control/venta`);
                console.log('numero de control recibido', response.data.numcontrol)
                this.numControl = response.data.numcontrol;
            } catch (error) {
                console.error('Error obteniendo número de control:', error);
                this.numControl = '00001'; // Valor por defecto si hay error
            }
        },
        nextStep() {
            if (!this.validateCurrentStep()) return
            if (this.paso === 1) {
                this.obtenerPromocionesCliente()
            }
            if (this.paso === 3 && this.tipoPago === 'credito' && this.credito) {
                if (this.total > parseFloat(this.credito.credito_disponible)) {
                    return Swal.fire({
                        icon: 'error',
                        title: 'Crédito Insuficiente',
                        text: `El total de la venta ($${this.total.toFixed(2)}) excede el crédito disponible del cliente ($${this.credito.credito_disponible}).`
                    });
                }
            }
            if (this.modo === 'despacho' && this.paso === 3) {
                const productosListos = this.productosSeleccionados.every(p => p.verificado);
                const obsequiosListos = this.obsequios.every(o => o.verificado);

                if (!productosListos || !obsequiosListos) {
                    return Swal.fire({
                        icon: 'warning',
                        title: 'Verificación incompleta',
                        text: 'Debe marcar todos los productos y obsequios como verificados.'
                    });
                }
            }

            if (this.paso < 4) this.paso++
            else this.enviarVenta()
        },
        prevStep() {
            if (this.paso > 1) this.paso--
        },
        goStep(n) {
            if (n < this.paso) this.paso = n
        },
        validateCurrentStep() {
            console.log('validandopaso')
            const container = this.$refs[`step${this.paso}`]
            if (!container) return true
            console.log(container)
            let valid = true
            const inputs = container.querySelectorAll('input[required], select[required]')
            inputs.forEach(i => {
                if (!i.checkValidity()) {
                    i.classList.add('is-invalid')
                    valid = false
                } else {
                    i.classList.remove('is-invalid')
                }
            })
            if (this.modo === 'despacho' && this.paso === 2) {
                if (!this.logistica.responsable_entrega || !this.logistica.recibido_por) valid = false;
            }

            return valid
        },
        async enviarVenta() {
            try {
                loading.show('Procesando venta...');
                this.cargando = true;
                // 1) Gestión de cliente nuevo
                if (this.tipoCliente === 'nuevo') {
                    const { data: nuevoCliente } = await api.post('/clientes', {
                        codigo: this.clienteSeleccionado.codigo,
                        nombre: this.clienteSeleccionado.nombre,
                        encargado: this.clienteSeleccionado.encargado || this.clienteSeleccionado.nombre,
                        rif: this.clienteSeleccionado.rif,
                        email: this.clienteSeleccionado.email || '',
                        telefono: this.clienteSeleccionado.telefono,
                        direccion: this.clienteSeleccionado.direccion,
                        tipo_contribuyente: this.clienteSeleccionado.tipo_contribuyente || 'ordinario',
                        empresa_id: 1
                    });
                    this.clienteSeleccionado = nuevoCliente;
                }

                // 2) Armar cabecera
                const cabecera = {
                    numcontrol: this.numControl,
                    cliente_id: this.clienteSeleccionado.id,
                    subtotal: this.subtotal,
                    ivatotal: this.ivatotal,
                    ivaexonerado: this.ivaExonerado || 0,
                    desc_total: this.descuentoTotal,
                    tipo_pago: this.tipoPago,
                    vendedor: this.vendedor || 'vendedor',
                    fecha_venta: this.fechaVenta,
                    fecha_entrega: this.fechaEntrega || null
                };

                // 3a) Líneas principales de productos
                const mainLines = this.productosSeleccionados.map(p => ({
                    producto_id: p.id,
                    cantidad: p.cantidad,
                    precio_unit: Number(p.precunid),
                    iva_producto: Number(p.porciva),
                    promocion_id: p.promocionId || null,
                    descuento_lineal: p.descuentoLineal || 0,
                    cantidad_obsequio: 0,
                    is_obsequio: false
                }));

                // 3b) Líneas de obsequio generadas en evaluarPromociones
                const giftLines = this.obsequios.map(o => ({
                    producto_id: o.id,
                    cantidad: o.cantidad,
                    precio_unit: 0,
                    iva_producto: 0,
                    promocion_id: o.promocion_id,
                    descuento_lineal: 0,
                    cantidad_obsequio: o.cantidad,
                    is_obsequio: true
                }));

                // 3c) Array final de detalles
                const productos = [...mainLines, ...giftLines];

                // 4) Payload de promociones
                const promociones = this.promosAplicadas.map(p => ({
                    promocion_id: p.id,
                    modo: p.modo,
                    monto_descuento: p.montoDescuento,
                    total_obsequios: p.totalObsequios
                }));

                // 5) Payload completo
                const payload = {
                    ...cabecera,
                    productos,
                    promociones: promociones.length ? promociones : null
                };

                console.log('Enviando payload:', payload);
                let idRedireccion;
                if (this.modo === 'crear') {
                    const respuesta = await api.post('/ventas/concreta', payload);
                    idRedireccion = respuesta.data.id || respuesta.data.data?.id;
                } else if (this.modo === 'editar') {
                    await api.put(`/ventas/${this.venta_id || this.id}`, payload);
                    idRedireccion = this.venta_id
                } else if (this.modo === 'despacho') {
                    // Actualizar venta (usando el ID de venta guardado) y luego despacho
                    await api.put(`/ventas/${this.venta_id}`, {
                        ...payload,
                        status_logistico: 'finalizada'
                    });
                    await api.put(`/despachoventas/${this.despacho_id}`, {
                        status: 'entregado',
                        responsable: this.logistica.responsable_entrega,
                        recibido_por: this.logistica.recibido_por,
                        fecha_despacho: this.fechaEntrega
                    });
                    idRedireccion = this.venta_id
                }

                const mensajeSuccess = this.modo === 'despacho'
                    ? '¡Despacho Confirmado! El inventario ha sido actualizado.'
                    : '¡La orden de venta ha sido registrada correctamente!';

                Swal.fire({
                    icon: 'success',
                    title: '¡Operación Exitosa!',
                    text: mensajeSuccess,
                    timer: 2500,
                    showConfirmButton: false
                });

                // Esperar a que la notificación se cierre antes de redirigir
                await new Promise(resolve => setTimeout(resolve, 2500));

                this.limpiarFormulario();
                this.$router.push(`/ventas/${idRedireccion}`);
            }
            catch (err) {
                console.error('Error al enviar la venta:', err.response?.data || err);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: err.response?.data?.message || 'No se pudo registrar la venta. Verifique los datos.'
                });
            } finally {
                loading.hide();
                this.cargando = false;
            }
        },
        limpiarCliente() {
            this.clienteSeleccionado = {}
        },
        limpiarDatos() {
            this.tipoPago = "Contado";
        },
        limpiarTabla() {
            this.productosSeleccionados = [];
            this.totalVentaUSD = 0;
        },
        limpiarFormulario() {
            this.numControl = "";
            this.limpiarCliente()
            this.limpiarDatos()
            this.limpiarTabla()
        },
    },
    async mounted() {
        if (this.id && (this.modo === 'editar' || this.modo === 'despacho')) {
            try {
                this.cargando = true;
                const { data } = await api.get(`/ventas/${this.id}`);
                this.venta_id = data.id;
                this.numControl = data.numcontrol;
                this.clienteSeleccionado = data.cliente;
                this.tipoPago = data.tipo_pago;
                this.fechaVenta = data.fecha_venta;
                this.fechaEntrega = data.fecha_entrega;
                this.vendedor = data.vendedor;

                if (data.despacho) {
                    this.despacho_id = data.despacho.id;
                }
                if (data.status_logistico === 'finalizada') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'El despacho de esta venta ya fue confirmado'
                    });
                    this.$router.push(`/ventas/${this.venta_id}`);
                }

                // 1. Cargamos SOLO productos reales (is_obsequio 0)
                this.productosSeleccionados = data.detalles
                    .filter(d => Number(d.is_obsequio) === 0)
                    .map(d => ({
                        ...d.producto,
                        cantidad: d.cantidad,
                        precunid: d.precio_unit, // Aseguramos que el motor use el precio guardado
                        porciva: d.iva_producto,
                        verificado: false
                    }));

                await this.obtenerPromocionesCliente();

                if (this.modo === 'despacho') {
                    // 2. En DESPACHO cargamos los obsequios EXACTOS de la DB
                    this.obsequios = data.detalles
                        .filter(d => Number(d.is_obsequio) === 1)
                        .map(d => ({
                            ...d.producto,
                            id: d.producto_id,
                            nombre: d.producto.descripcion,
                            cantidad: d.cantidad,
                            promocion_id: d.promocion_id,
                            verificado: false
                        }));
                }

                // 3. En ambos casos (EDITAR/DESPACHO) evaluamos promociones 
                // para recalcular descuentos y obsequios dinámicos
                this.evaluarPromociones();
            } finally {
                this.cargando = false;
            }
        } else {
            this.obtenerNumeroControl();
        }
    }
};
</script>
